export const DELETED_FORMULA_REFERENCE_CODE = 'DELETED_REFERENCE';

export interface FormulaReferenceOption {
  avatar?: string;
  depth?: number;
  disabled?: boolean;
  id?: null | number | string;
  invalid?: boolean;
  link?: string;
  name: string;
}
